import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaMapMarkerAlt, FaUser, FaClock, FaLeaf, FaSun, FaGlassCheers, FaHome } from 'react-icons/fa';
import { MdCelebration } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { BsFillGiftFill } from 'react-icons/bs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import FiestaSpinner2 from '../shared/FiestaSpinner2';

import { API_BASE_URL } from '../../config/config.js'; 

// Mapeo de iconos por tipo
const iconMap = {
    jardin: <FaLeaf className='icon-jardin general' />,
    infantil: <BsFillGiftFill className='icon-infantil general' />,
    salon: <FaGlassCheers className='icon-salon general' />,
    hacienda: <FaHome className='icon-hacienda general' />,
    terraza: <FaSun className='icon-terraza general' />,
};

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export const TypeSectionCarrusel = ({ title, type, typeId }) => {
    const pageSize = 6;
    const [services, setServices] = useState([]); // Estado para almacenar los datos de los servicios
    const [loading, setLoading] = useState(true); // Estado de carga
    const [error, setError] = useState(null); // Estado para manejar errores
    const navigate = useNavigate(); // Hook de navegación

    const formatNameForUrl = (name) => {
        return name
          .normalize("NFD")                      // Descompone letras con acentos
          .replace(/[\u0300-\u036f]/g, "")       // Elimina los acentos
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-')                  // Reemplaza espacios por guiones
          .replace(/[^a-z0-9\-]/g, '');          // Elimina caracteres no válidos
      };

    
   // Función para manejar la navegación
   const handleLinkType = (type) => {
    navigate(`/espacios-para-tu-evento/${type}`, { state: { scrollToTop: true } });
    };

    // Función que maneja la navegación al hacer clic en el nombre o la imagen
    const handleLinkClick = (name, id, imagePrincipal,mostImportantTypeEvents) => {
        if (typeof name !== 'string' || !name.trim()) {
            console.warn('El nombre proporcionado no es válido:', name); // Advertencia si `name` no es válido
            return;
        }

        const formattedName = formatNameForUrl(name); // Formatear el nombre para la URL
        navigate(`/espacios-para-tu-evento/${type}/${formattedName}/${id}`, {
            state: { selectedId: id, name, mostImportantTypeEvents, imagePrincipal, type },
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const url = `${API_BASE_URL}/lugares/tipoLugares/${typeId}?size=${pageSize}&sortBy=id`;
                const response = await fetch(url, {

                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'ngrok-skip-browser-warning': 'true',
                    },
                });

                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                const data = await response.json();
                setServices(data.content);
                
            } catch (error) {
                console.error('Error:', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [typeId]);

    if (loading) return <div className="centered-spinner"><FiestaSpinner2 /></div>;
    if (error) return <div>Error: {error}</div>;
    if (services.length === 0) return null;

    const slidesToShow = services.length <= 3 ? services.length : 3;
     console.log ("Esto es setservies", services)
    return (
        <section className='custom-carousel-section'>
            <div className="custom-carousel-title-container">
                <h2
                    className="custom-carousel-title"
                    onClick={() => handleLinkType(type)}
                >
                    <div className="icon-container">
                        {iconMap[type]}
                    </div>
                    <span className="title">{title}</span>
                </h2>
                <strong className="custom-carousel-link" onClick={() => handleLinkType(type)}>Ver todos</strong>
            </div>

            <Slider
                {...settings}
                className="custom-carousel-slider"
                slidesToShow={slidesToShow}
                slidesToScroll={slidesToShow}
            >
                {services.map(({ id, imagePrincipal, name, mostImportantTypeEvents, address, capacitymax, priceInitial, priceFinal, hours }) => (
                    <div key={id} className="custom-carousel-item">
                        <div className="custom-carousel-image-container">
                            <img
                                src={imagePrincipal || 'default-image.png'}
                                alt={name || 'No disponible'}
                                className="custom-carousel-image"
                                onClick={() => handleLinkClick(name, id, imagePrincipal,mostImportantTypeEvents)} // Clic en imagen
                            />
                        </div>
                        <div className={`${type}-info`}>
                            <h2 onClick={() => handleLinkClick(name, id, imagePrincipal, mostImportantTypeEvents)}>
                                {iconMap[type]} {name || 'No disponible'}
                            </h2>
                            <section className={`${type}-details`}>
                                <div className='detail-item'>
                                    <div className='detail-container first'>
                                        <div className='detail-info'>
                                        <MdCelebration className='detail-icon celebration' />
                                        <span>
                                            {(mostImportantTypeEvents && typeof mostImportantTypeEvents === 'string' 
                                                ? mostImportantTypeEvents.split(',') 
                                                : []
                                            )
                                            .filter(evento => evento.trim()) // Eliminar posibles entradas vacías
                                            .slice(0, 3)
                                            .join(', ') || 'No hay eventos disponibles'}
                                        </span>
                                        </div>
                                        <div className='detail-info'>
                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="maps-button"
                                            >
                                                <FaMapMarkerAlt className='detail-icon maps' />
                                            </a>
                                            <span className='truncate'>{address}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='detail-container'>
                                    <div className='detail-info'>
                                        <FaUser className='detail-icon user' />
                                        <span>Cap. máx: <span className='capacity'>{capacitymax || 'No disponible'}</span></span>
                                    </div>
                                    <div className='detail-info'>
                                        <FontAwesomeIcon className='icon-price detail-icon available' icon={faMoneyBill} color="green" />
                                        <span>${priceInitial} - ${priceFinal || 'No disponible'}</span>
                                    </div>
                                    <div className='detail-info'>
                                        <FaClock className='detail-icon available' />
                                        <span className='time-event'>
                                            {hours || 'No disponible'}
                                        </span>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};


// import React, { useState, useEffect } from 'react';
// import Slider from 'react-slick';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { FaMapMarkerAlt, FaUser, FaClock, FaLeaf, FaSun, FaGlassCheers, FaHome } from 'react-icons/fa';
// import { MdCelebration } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';
// import { BsFillGiftFill } from 'react-icons/bs';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
// import FiestaSpinner2 from '../shared/FiestaSpinner2';

// import { API_BASE_URL } from '../../config/config.js';

// // Mapeo de iconos por tipo
// const iconMap = {
//     jardin: <FaLeaf className='icon-jardin general' />,
//     infantil: <BsFillGiftFill className='icon-infantil general' />,
//     salon: <FaGlassCheers className='icon-salon general' />,
//     hacienda: <FaHome className='icon-hacienda general' />,
//     terraza: <FaSun className='icon-terraza general' />,
// };

// const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: false,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     initialSlide: 0,
//     responsive: [
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 1,
//             },
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 1,
//             },
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//             },
//         },
//     ],
// };

// export const TypeSectionCarrusel = ({ title, type, typeId }) => {
//     const pageSize = 6;
//     const [services, setServices] = useState([]); // Estado para almacenar los datos de los servicios
//     const [loading, setLoading] = useState(true); // Estado de carga
//     const [error, setError] = useState(null); // Estado para manejar errores
//     const navigate = useNavigate(); // Hook de navegación

//     // Función para formatear el nombre para la URL (convertir espacios a guiones y todo en minúsculas)
//     const formatNameForUrl = (name) => {
//         return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, ''); // Convierte a minúsculas y reemplaza espacios por guiones
//     };
    
//     // Función para manejar la navegación
//     const handleLinkType = (type) => {
//         navigate(`/espacios-para-tu-evento/${type}`, { state: { scrollToTop: true } });
//     };

//     // Función que maneja la navegación al hacer clic en el nombre o la imagen
//     const handleLinkClick = (name, id, imagePrincipal, mostImportantTypeEvents) => {
//         if (typeof name !== 'string' || !name.trim()) {
//             console.warn('El nombre proporcionado no es válido:', name); // Advertencia si `name` no es válido
//             return;
//         }

//         const formattedName = formatNameForUrl(name); // Formatear el nombre para la URL
//         navigate(`/espacios-para-tu-evento/${type}/${formattedName}`, {
//             state: { selectedId: id, name, mostImportantTypeEvents, imagePrincipal, type },
//         });
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true);

//                 const url = `${API_BASE_URL}/lugares/tipoLugares/${typeId}?size=${pageSize}&sortBy=id`;
//                 const response = await fetch(url, {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'ngrok-skip-browser-warning': 'true',
//                     },
//                 });

//                 if (!response.ok) {
//                     throw new Error(`Error HTTP: ${response.status}`);
//                 }

//                 const data = await response.json();
//                 setServices(data.content);
                
//             } catch (error) {
//                 console.error('Error:', error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [typeId]);

//     if (loading) return <div className="centered-spinner"><FiestaSpinner2 /></div>;
//     if (error) return <div>Error: {error}</div>;
//     if (services.length === 0) return null;

//     // Determinar el número de servicios que se mostrarán
//     const slidesToShow = services.length <= 3 ? services.length : 3;

//     // Si hay entre 1 y 3 servicios, mostramos solo uno con el estilo del carrusel, pero sin carrusel interactivo
//     const shouldShowCarousel = services.length > 3;

//     return (
//         <section className='custom-carousel-section'>
//             <div className="custom-carousel-title-container">
//                 <h2
//                     className="custom-carousel-title"
//                     onClick={() => handleLinkType(type)}
//                 >
//                     <div className="icon-container">
//                         {iconMap[type]}
//                     </div>
//                     <span className="title">{title}</span>
//                 </h2>
//                 <strong className="custom-carousel-link" onClick={() => handleLinkType(type)}>Ver todos</strong>
//             </div>

//             {shouldShowCarousel ? (
//                 // Si hay más de 3 servicios, mostramos el carrusel
//                 <Slider
//                     {...settings}
//                     className="custom-carousel-slider"
//                     slidesToShow={slidesToShow}
//                     slidesToScroll={1}
//                 >
//                     {services.map(({ id, imagePrincipal, name, mostImportantTypeEvents, address, capacitymax, priceInitial, priceFinal, hours }) => (
//                         <div key={id} className="custom-carousel-item">
//                             <div className="custom-carousel-image-container">
//                                 <img
//                                     src={imagePrincipal || 'default-image.png'}
//                                     alt={name || 'No disponible'}
//                                     className="custom-carousel-image"
//                                     onClick={() => handleLinkClick(name, id, imagePrincipal, mostImportantTypeEvents)} // Clic en imagen
//                                 />
//                             </div>
//                             <div className={`${type}-info`}>
//                                 <h2 onClick={() => handleLinkClick(name, id, imagePrincipal, mostImportantTypeEvents)}>
//                                     {iconMap[type]} {name || 'No disponible'}
//                                 </h2>
//                                 <section className={`${type}-details`}>
//                                     <div className='detail-item'>
//                                         <div className='detail-container first'>
//                                             <div className='detail-info'>
//                                                 <MdCelebration className='detail-icon celebration' />
//                                                 <span>
//                                                     {(mostImportantTypeEvents && typeof mostImportantTypeEvents === 'string' 
//                                                         ? mostImportantTypeEvents.split(',') 
//                                                         : []
//                                                     )
//                                                     .filter(evento => evento.trim()) // Eliminar posibles entradas vacías
//                                                     .slice(0, 3)
//                                                     .join(', ') || 'No hay eventos disponibles'}
//                                                 </span>
//                                             </div>
//                                             <div className='detail-info'>
//                                                 <a
//                                                     href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     className="maps-button"
//                                                 >
//                                                     <FaMapMarkerAlt className='detail-icon maps' />
//                                                 </a>
//                                                 <span className='truncate'>{address}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className='detail-container'>
//                                         <div className='detail-info'>
//                                             <FaUser className='detail-icon user' />
//                                             <span>Cap. máx: <span className='capacity'>{capacitymax || 'No disponible'}</span></span>
//                                         </div>
//                                         <div className='detail-info'>
//                                             <FontAwesomeIcon className='icon-price detail-icon available' icon={faMoneyBill} color="green" />
//                                             <span>${priceInitial} - ${priceFinal || 'No disponible'}</span>
//                                         </div>
//                                         <div className='detail-info'>
//                                             <FaClock className='detail-icon available' />
//                                             <span className='time-event'>
//                                                 {hours || 'No disponible'}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </section>
//                             </div>
//                         </div>
//                     ))}
//                 </Slider>
//             ) : (
//                 // Si hay entre 1 y 3 servicios, mostramos de forma estática
//                 <div className="custom-carousel-item">
//                     {services.map(({ id, imagePrincipal, name, mostImportantTypeEvents, address, capacitymax, priceInitial, priceFinal, hours }) => (
//                         <div key={id} className="custom-carousel-item-static">
//                             <div className="custom-carousel-image-container">
//                                 <img
//                                     src={imagePrincipal || 'default-image.png'}
//                                     alt={name || 'No disponible'}
//                                     className="custom-carousel-image"
//                                     onClick={() => handleLinkClick(name, id, imagePrincipal, mostImportantTypeEvents)} // Clic en imagen
//                                 />
//                             </div>
//                             <div className={`${type}-info`}>
//                                 <h2 onClick={() => handleLinkClick(name, id, imagePrincipal, mostImportantTypeEvents)}>
//                                     {iconMap[type]} {name || 'No disponible'}
//                                 </h2>
//                                 <section className={`${type}-details`}>
//                                     <div className='detail-item'>
//                                         <div className='detail-container first'>
//                                             <div className='detail-info'>
//                                                 <MdCelebration className='detail-icon celebration' />
//                                                 <span>
//                                                     {(mostImportantTypeEvents && typeof mostImportantTypeEvents === 'string' 
//                                                         ? mostImportantTypeEvents.split(',') 
//                                                         : []
//                                                     )
//                                                     .filter(evento => evento.trim()) // Eliminar posibles entradas vacías
//                                                     .slice(0, 3)
//                                                     .join(', ') || 'No hay eventos disponibles'}
//                                                 </span>
//                                             </div>
//                                             <div className='detail-info'>
//                                                 <a
//                                                     href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     className="maps-button"
//                                                 >
//                                                     <FaMapMarkerAlt className='detail-icon maps' />
//                                                 </a>
//                                                 <span className='truncate'>{address}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className='detail-container'>
//                                         <div className='detail-info'>
//                                             <FaUser className='detail-icon user' />
//                                             <span>Cap. máx: <span className='capacity'>{capacitymax || 'No disponible'}</span></span>
//                                         </div>
//                                         <div className='detail-info'>
//                                             <FontAwesomeIcon className='icon-price detail-icon available' icon={faMoneyBill} color="green" />
//                                             <span>${priceInitial} - ${priceFinal || 'No disponible'}</span>
//                                         </div>
//                                         <div className='detail-info'>
//                                             <FaClock className='detail-icon available' />
//                                             <span className='time-event'>
//                                                 {hours || 'No disponible'}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 </section>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </section>
//     );
// };
